import React from "react";
import { useAppState, useSelectedSession } from "../../state";

interface Countdown {
  minutes: number;
  seconds: number;
}

export const CountdownTimer = () => {
  const [, dispatch] = useAppState();
  const session = useSelectedSession();
  const activeTask = session.tasks[0];

  const [isPaused, setIsPaused] = React.useState<boolean>(false);
  const [time, setTime] = React.useState<Countdown>({
    minutes: activeTask ? activeTask.minutes : 25,
    seconds: 0,
  });

  const [elapsedSeconds, setElapsedSeconds] = React.useState<number>(0);
  const [isAddingNewTask, setIsAddingNewTask] = React.useState<boolean>(false);

  const [playedSound, setPlayedSound] = React.useState<boolean>(false);

  const playSound = async () => {
    var audio = new Audio(
      // ding ding sound
      "https://www.freesoundslibrary.com/wp-content/uploads/2021/06/ding-ding-sound-effect.mp3"
      // "https://interactive-examples.mdn.mozilla.net/media/cc0-audio/t-rex-roar.mp3"
    );
    audio.play();
  };

  const handleOnFocusNewTask = () => {
    setIsAddingNewTask(!isAddingNewTask);
  };

  React.useEffect(() => {
    const tick = (elapsedSeconds: number) => {
      if (!activeTask?.active) return;
      setElapsedSeconds(elapsedSeconds + 1);
      if (time.minutes === 0 && time.seconds === 0)
        // TODO: setActiveTask -1
        // play audio
        return { minutes: 0, seconds: 0 };
      else if (time.seconds === 0) {
        setTime({ minutes: time.minutes - 1, seconds: 59 });
      } else {
        setTime({
          minutes: time.minutes,
          seconds: time.seconds - 1,
        });
      }
    };

    const timerId = setInterval(() => {
      let time = tick(elapsedSeconds);
      if (!playedSound && time && time.minutes === 0 && time.seconds === 0) {
        playSound();
        setPlayedSound(true);
      }
    }, 1000);
    return () => clearInterval(timerId);
  }, [elapsedSeconds, playedSound, time.minutes, time.seconds, activeTask]);

  document.body.onkeyup = function(e) {
    // do not make it possible to pause while adding a new task
    if (isAddingNewTask) {
      return;
    }
    if (e.key === " ") {
      switch (isPaused) {
        case true:
          setIsPaused(false);
          dispatch({
            type: "SET_TASK_ACTIVE",
            payload: {
              sessionId: session.id,
              taskId: activeTask?.id!,
              active: true,
            },
          });
          break;
        case false:
          setIsPaused(true);
          //your code
          const time = Math.floor(elapsedSeconds / 60);
          dispatch({
            type: "SET_TASK_TIME",
            payload: { sessionId: session.id, taskId: activeTask?.id!, time },
          });
          dispatch({
            type: "SET_TASK_ACTIVE",
            payload: {
              sessionId: session.id,
              taskId: activeTask?.id!,
              active: false,
            },
          });
          break;
      }
    }
  };

  return (
    <div className="flex justify-between">
      <div className="flex focus:outline-0 text-2xl my-auto font-bold">
        {activeTask ? (
          activeTask.name
        ) : (
          <input
            type="text"
            placeholder="what are you working on?"
            onFocus={handleOnFocusNewTask}
            onBlur={handleOnFocusNewTask}
            className="bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-300 p-1 rounded-md"
          ></input>
        )}
      </div>
      <div className="my-auto text-2xl font-semibold text-gray-600">
        <p>{`${time.minutes.toString().padStart(2, "0")}:${time.seconds
          .toString()
          .padStart(2, "0")}`}</p>
      </div>
      <button
        type="button"
        className="bg-gray-300 hover:bg-gray-400 text-gray-600 py-2 px-4 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300"
        onClick={() => {
          const time = Math.floor(elapsedSeconds / 60);
          dispatch({
            type: "SET_SESSION_ACTIVE",
            payload: { sessionId: session.id, active: false },
          });
          dispatch({
            type: "SET_TASK_TIME",
            payload: { sessionId: session.id, taskId: activeTask?.id!, time },
          });
          dispatch({
            type: "SET_TASK_ACTIVE",
            payload: {
              sessionId: session.id,
              taskId: activeTask?.id!,
              active: false,
            },
          });
        }}
      >
        <i className="fa-solid fa-pause">Back</i>
      </button>
    </div>
  );
};
